/**
 * @generated SignedSource<<fca334330256e370fee3047177010dfd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ErrorKind = "DISCOURSE" | "GRAMMAR" | "LEXIS" | "PROSODY" | "%future added value";
export type PracticeResult = "RECURRED" | "TARGETED" | "USED_CORRECTLY" | "%future added value";
export type SessionStatus = "ACTIVE" | "DEBRIEFED" | "DEBRIEFING" | "ENDED" | "FAILED" | "%future added value";
export type ProgressViewQuery$variables = {
  from: any;
  since: any;
  to: any;
};
export type ProgressViewQuery$data = {
  readonly me: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly audience: string;
      } | null | undefined;
      readonly id: string;
      readonly lessonDays: ReadonlyArray<{
        readonly completed: number;
        readonly localDay: any;
        readonly plays: number;
      }>;
      readonly newestPage: ReadonlyArray<{
        readonly sticker: string;
      }>;
      readonly practiceItems: ReadonlyArray<{
        readonly exemplar: {
          readonly learnerForm: string;
          readonly targetForm: string;
        } | null | undefined;
        readonly id: string;
        readonly kind: ErrorKind;
        readonly lastPractisedAt: any | null | undefined;
        readonly occurrences: number;
        readonly pattern: string;
        readonly practisable: boolean;
      }>;
      readonly sessions: {
        readonly nodes: ReadonlyArray<{
          readonly character: {
            readonly displayName: string;
          } | null | undefined;
          readonly id: string;
          readonly practice: ReadonlyArray<{
            readonly item: {
              readonly exemplar: {
                readonly targetForm: string;
              } | null | undefined;
              readonly id: string;
              readonly pattern: string;
            };
            readonly outcome: PracticeResult;
          }>;
          readonly startedAt: any;
          readonly status: SessionStatus;
          readonly topic: string | null | undefined;
        }>;
      };
      readonly " $fragmentSpreads": FragmentRefs<"ProgressViewWindow_learner" | "ProgressViewWords_learner">;
    } | null | undefined;
  } | null | undefined;
};
export type ProgressViewQuery = {
  response: ProgressViewQuery$data;
  variables: ProgressViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "since"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "to"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "from",
      "variableName": "from"
    },
    {
      "kind": "Variable",
      "name": "to",
      "variableName": "to"
    }
  ],
  "concreteType": "LessonDay",
  "kind": "LinkedField",
  "name": "lessonDays",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sticker",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pattern",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetForm",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 50
    }
  ],
  "concreteType": "PracticeItem",
  "kind": "LinkedField",
  "name": "practiceItems",
  "plural": true,
  "selections": [
    (v3/*:: as any*/),
    (v8/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "occurrences",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastPractisedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "practisable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Exemplar",
      "kind": "LinkedField",
      "name": "exemplar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "learnerForm",
          "storageKey": null
        },
        (v9/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "practiceItems(first:50)"
},
v11 = {
  "kind": "Variable",
  "name": "since",
  "variableName": "since"
},
v12 = [
  (v11/*:: as any*/)
],
v13 = {
  "kind": "Literal",
  "name": "spoken",
  "value": true
},
v14 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  (v13/*:: as any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "topic",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outcome",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "PracticeOutcome",
  "kind": "LinkedField",
  "name": "practice",
  "plural": true,
  "selections": [
    (v19/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PracticeItem",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        (v8/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Exemplar",
          "kind": "LinkedField",
          "name": "exemplar",
          "plural": false,
          "selections": [
            (v9/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v22 = [
  (v21/*:: as any*/),
  (v11/*:: as any*/),
  (v13/*:: as any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = [
  (v21/*:: as any*/),
  (v11/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProgressViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "newestPage",
                "args": (v6/*:: as any*/),
                "concreteType": "ScrapbookPage",
                "kind": "LinkedField",
                "name": "scrapbook",
                "plural": true,
                "selections": [
                  (v7/*:: as any*/)
                ],
                "storageKey": "scrapbook(first:1)"
              },
              (v10/*:: as any*/),
              {
                "args": (v12/*:: as any*/),
                "kind": "FragmentSpread",
                "name": "ProgressViewWindow_learner"
              },
              {
                "args": (v12/*:: as any*/),
                "kind": "FragmentSpread",
                "name": "ProgressViewWords_learner"
              },
              {
                "alias": null,
                "args": (v14/*:: as any*/),
                "concreteType": "SessionConnection",
                "kind": "LinkedField",
                "name": "sessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Session",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v3/*:: as any*/),
                      (v15/*:: as any*/),
                      (v16/*:: as any*/),
                      (v17/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Character",
                        "kind": "LinkedField",
                        "name": "character",
                        "plural": false,
                        "selections": [
                          (v18/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "sessions(first:20,spoken:true)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "ProgressViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "newestPage",
                "args": (v6/*:: as any*/),
                "concreteType": "ScrapbookPage",
                "kind": "LinkedField",
                "name": "scrapbook",
                "plural": true,
                "selections": [
                  (v7/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": "scrapbook(first:1)"
              },
              (v10/*:: as any*/),
              {
                "alias": "window",
                "args": (v22/*:: as any*/),
                "concreteType": "SessionConnection",
                "kind": "LinkedField",
                "name": "sessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SessionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Session",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          (v17/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SessionFluency",
                            "kind": "LinkedField",
                            "name": "fluency",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "words",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "speakingMs",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "speechRateWpm",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PracticeOutcome",
                            "kind": "LinkedField",
                            "name": "practice",
                            "plural": true,
                            "selections": [
                              (v19/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PracticeItem",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v3/*:: as any*/),
                                  (v8/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v23/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v25/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "window",
                "args": (v22/*:: as any*/),
                "filters": [
                  "since",
                  "spoken"
                ],
                "handle": "connection",
                "key": "ProgressView_window",
                "kind": "LinkedHandle",
                "name": "sessions"
              },
              {
                "alias": null,
                "args": (v26/*:: as any*/),
                "concreteType": "VocabularyItemConnection",
                "kind": "LinkedField",
                "name": "vocabularyItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VocabularyItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VocabularyItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstMetAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "source",
                            "storageKey": null
                          },
                          (v3/*:: as any*/),
                          (v23/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v25/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v26/*:: as any*/),
                "filters": [
                  "since"
                ],
                "handle": "connection",
                "key": "ProgressView_vocabularyItems",
                "kind": "LinkedHandle",
                "name": "vocabularyItems"
              },
              {
                "alias": null,
                "args": (v14/*:: as any*/),
                "concreteType": "SessionConnection",
                "kind": "LinkedField",
                "name": "sessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Session",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v3/*:: as any*/),
                      (v15/*:: as any*/),
                      (v16/*:: as any*/),
                      (v17/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Character",
                        "kind": "LinkedField",
                        "name": "character",
                        "plural": false,
                        "selections": [
                          (v18/*:: as any*/),
                          (v3/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "sessions(first:20,spoken:true)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4e40f38a88c727abdaf08f9eea6008f4",
    "id": null,
    "metadata": {},
    "name": "ProgressViewQuery",
    "operationKind": "query",
    "text": "query ProgressViewQuery(\n  $since: DateTime!\n  $from: NaiveDate!\n  $to: NaiveDate!\n) {\n  me {\n    learner {\n      id\n      lessonDays(from: $from, to: $to) {\n        localDay\n        plays\n        completed\n      }\n      defaultCharacter {\n        audience\n        id\n      }\n      newestPage: scrapbook(first: 1) {\n        sticker\n        id\n      }\n      practiceItems(first: 50) {\n        id\n        pattern\n        kind\n        occurrences\n        lastPractisedAt\n        practisable\n        exemplar {\n          learnerForm\n          targetForm\n        }\n      }\n      ...ProgressViewWindow_learner_2xCj2c\n      ...ProgressViewWords_learner_2xCj2c\n      sessions(first: 20, spoken: true) {\n        nodes {\n          id\n          topic\n          status\n          startedAt\n          character {\n            displayName\n            id\n          }\n          practice {\n            outcome\n            item {\n              id\n              pattern\n              exemplar {\n                targetForm\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProgressViewWindow_learner_2xCj2c on Learner {\n  window: sessions(first: 100, since: $since, spoken: true) {\n    edges {\n      node {\n        id\n        startedAt\n        fluency {\n          words\n          speakingMs\n          speechRateWpm\n        }\n        practice {\n          outcome\n          item {\n            id\n            pattern\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ProgressViewWords_learner_2xCj2c on Learner {\n  vocabularyItems(first: 100, since: $since) {\n    edges {\n      node {\n        firstMetAt\n        source\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "39086a02fca39ffa1cab299a75ab64d3";

export default node;
